export const Twitter = () => {
  return (
    <svg
      width="32"
      height="26"
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.7107 6.47966C28.7311 6.76403 28.7311 7.04845 28.7311
          7.33281C28.7311 16.0062 22.1321 26 10.0711 26C6.35534 26 2.90357
          24.9234 0 23.0547C0.52794 23.1156 1.0355 23.1359 1.58376 23.1359C4.64971
          23.1359 7.47209 22.1 9.72591 20.3328C6.84265 20.2719 4.42639 18.3828
          3.59389 15.7828C4.00002 15.8437 4.40608 15.8843 4.83252 15.8843C5.42133
          15.8843 6.01021 15.8031 6.5584 15.6609C3.55333 15.0515 1.29944 12.4109
          1.29944 9.22186V9.14064C2.17251 9.62815 3.18783 9.93283 4.26389 9.97341C2.49738
          8.79526 1.34007 6.78435 1.34007 4.50933C1.34007 3.2906 1.66488 2.17341 2.23345
          1.19841C5.4619 5.17965 10.3147 7.77961 15.7563 8.06403C15.6548 7.57653 15.5939
          7.06877 15.5939 6.56095C15.5939 2.94528 18.5178 0 22.1523 0C24.0406 0 25.7462
          0.792185 26.9442 2.07187C28.4264 1.78751 29.8477 1.23905 31.1066 0.487504C30.6192
          2.01098 29.5837 3.29066 28.2234 4.10311C29.5432 3.96099 30.8224 3.59528 32
          3.08752C31.1067 4.38747 29.9899 5.54524 28.7107 6.47966Z"
        fill="#051C2C"
      />
    </svg>
  )
}
